import styled, { keyframes } from "styled-components";

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  background-image: ${({ img }) => `url(${img})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  min-height: ${({ tall }) =>
    tall ? "clamp(420px, 56vh, 560px)" : "clamp(300px, 38vh, 380px)"};

  display: flex;
  align-items: stretch;

  position: relative;
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;

  background: linear-gradient(
    100deg,
    rgba(16, 23, 58, 0.94) 0%,
    rgba(22, 31, 76, 0.78) 48%,
    rgba(22, 31, 76, 0.42) 100%
  );

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Wrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;

  position: relative;
  z-index: 2;

  padding: clamp(48px, 7vw, 88px) 0;
`;

export const Holder = styled.div`
  max-width: 720px;
`;

export const Eyebrow = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 10px;

  margin: 0 0 18px;

  font-family: ${({ theme: { font } }) => font.heading};
  font-size: ${({ theme: { font } }) => font.sub};
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${({ theme: { colors } }) => colors.main.yellow};

  animation: ${fadeUp} 0.7s ease both;

  &::before {
    content: "";
    width: 32px;
    height: 2px;
    background-color: ${({ theme: { colors } }) => colors.main.yellow};
  }
`;

export const Title = styled.h1`
  font-family: ${({ theme: { font } }) => font.heading};
  font-size: ${({ theme: { font } }) => font.display};
  color: ${({ theme: { colors } }) => colors.white};
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.02em;

  margin: 0;

  animation: ${fadeUp} 0.7s ease 0.1s both;
`;

export const SubTitle = styled.p`
  font-size: ${({ theme: { font } }) => font.title};
  color: rgba(255, 255, 255, 0.82);
  font-weight: 400;
  line-height: 1.6;
  max-width: 560px;

  margin: 18px 0 0;

  animation: ${fadeUp} 0.7s ease 0.18s both;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;

  margin-top: 32px;

  animation: ${fadeUp} 0.7s ease 0.26s both;
`;

export const GhostLink = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 11px 26px;

  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: ${({ theme: { radii } }) => radii.sm};

  color: ${({ theme: { colors } }) => colors.white};
  font-family: ${({ theme: { font } }) => font.heading};
  font-weight: 600;
  font-size: ${({ theme: { font } }) => font.main};
  line-height: 1.2;

  transition: background-color ${({ theme: { transition } }) => transition.fast},
    border-color ${({ theme: { transition } }) => transition.fast};

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.75);
  }

  svg {
    width: 17px;
    height: 17px;
  }
`;
